import HeartIcon from "./HeartIcon.mjs";

/** @type {GlyphIcon} */
export default HeartIcon;